import { StatusChip } from '@batiflow/ui';
import { CheckmarkCircle16Regular, Clock16Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';

export interface AckChipProps {
  acknowledged: number;
  total: number;
}

/**
 * "2 accusés sur 3": a text and an icon (a check when everyone answered, a clock while some are
 * missing), so the state never rests on colour alone.
 */
export function AckChip({ acknowledged, total }: AckChipProps) {
  const { t } = useTranslation('transmittals');
  const complete = total > 0 && acknowledged >= total;
  return (
    <StatusChip
      intent={complete ? 'success' : 'warning'}
      icon={complete ? <CheckmarkCircle16Regular /> : <Clock16Regular />}
      label={t('ack.summary', { acknowledged, total })}
    />
  );
}
